import { takeEvery, put, call, select, SagaReturnType } from 'redux-saga/effects';
import { therapyPlanningAction } from 'src/redux/actions/constant';
import therapyPlanningService from '../../../../services/apiServices/therapyPlanning/therapyPlanning';

const {
  GET_THERAPY_PLANNING_SUMMARY_SUCCESS_2_0,
  GET_THERAPY_PLANNING_SUMMARY_REQUEST_2_0,
  GET_THERAPY_PLANNING_SUMMARY_FAILURE_2_0,
  GET_THERAPY_PLANNING_SUMMARY_LOADING_2_0,
  GET_THERAPY_PLANNING_SUMMARY_RESET_2_0,
} = therapyPlanningAction;

function* getTherapyPlanningSummary_2_0(payload: any): SagaReturnType<any> {
  try {
    
    yield put({
      type: GET_THERAPY_PLANNING_SUMMARY_LOADING_2_0,
      requestDiscipline: payload?.payload?.therapyType ? payload?.payload?.therapyType : 'ALL',
    });
    const response = yield call(therapyPlanningService.getTherapyPlanningSummary, payload?.payload);
    if (response?.status === 200) {
      // Guard: discard stale responses if patient changed since request was made
      const currentPatientUuid: string = yield select(
        (state: any) => state?.selectPatientReducer?.patientInfo?.uuid
      );
      if (payload?.payload?.patientId && payload?.payload?.patientId !== currentPatientUuid) {
        return;
      }
      yield put({
        type: GET_THERAPY_PLANNING_SUMMARY_SUCCESS_2_0,
        payload: {
          response: response.data,
          therapyType: payload?.payload?.therapyType,
          requestPayload: payload?.payload?.params,
          source: payload?.payload?.source,
        },
      });
    } else {
      throw response.data;
    }
  } catch (error) {
    yield put({ type: GET_THERAPY_PLANNING_SUMMARY_FAILURE_2_0, payload: error });
  }
}

function* getTherapyPlanningSummarySaga_2_0() {
  yield takeEvery(GET_THERAPY_PLANNING_SUMMARY_REQUEST_2_0, getTherapyPlanningSummary_2_0);
}

export default getTherapyPlanningSummarySaga_2_0;
